import React, { useState, useEffect, useMemo, useRef } from "react";
import dynamic from "next/dynamic";
//
import MainTemplate from "../../components/Templates/MainTemplate";
import HeroSection from "./HeroSection";
import HowItWorksSection from "./HowItWorksSection";
import NutritionistVideo from "./NutritionistVideo";
// import HelpSection from "./HelpSection";
import FeaturesSection from "./FeaturesSection";
const PaymentSuccessSection = dynamic(() => import("./PaymentSuccessSection"), {
  ssr: false,
});
//
import NutritionForm from "../../components/Organisms/NutritionForm";
//
import theme from "../../foundation/Theme";
import { useWindowDimensions } from "../../hooks";
import {
  appendHotJarScript,
  handleScrollToSection,
  timezone,
} from "../../utils";
//
import { useAppSelector } from "@/hooks";
//
import { StyledTestimonials } from "./style";
//
import mapNutritionPackagesData from "./mapNutritionPackagesData";
//
const headerInitialValues = {
  dark: false,
  color: "transparent",
  isSticky: false,
};

function NutritionPackagesPage({ h1Text }) {
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const formRef = useRef();
  const testimonialsRef = useRef();
  const howItWorksRef = useRef();

  const { data, isLoading, error } =
    useAppSelector((state) => state.healthProgramV1) || {};

  const [headerValue, setHeaderValue] = useState(headerInitialValues);
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);
  const [userMobileNumber, setUserMobileNumber] = useState("");

  useEffect(() => {
    const detectScroll = () => {
      window.onscroll = () => {
        const heroSection = document.getElementById("hero-section");
        if (heroSection) {
          let heroBottom = heroSection?.getBoundingClientRect().bottom;
          if (heroBottom <= 0 && !headerValue?.isSticky) {
            setHeaderValue({
              dark: false,
              color: theme.colorsV2.gray.shade_100,
              isSticky: true,
            });
          } else if (heroBottom > 0 && headerValue?.isSticky) {
            setHeaderValue(headerInitialValues);
          }
        }
      };
    };
    detectScroll();
  });

  //FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  const scrollToForm = () => handleScrollToSection({ refElement: formRef });
  const scrollToHowItWorks = () =>
    handleScrollToSection({ refElement: howItWorksRef });

  const {
    heroSectionData,
    howItWorksData,
    // helpSectionData,
    featuresSectionData,
    testimonialsData,
    leadNutritionistData,
    formData,
  } = useMemo(() => {
    if (Object.keys(data || {}).length === 0) return {};
    return mapNutritionPackagesData(data);
  }, [data]);

  const Form = (
    <NutritionForm
      data={{ ...formData, setUserMobileNumber }}
      setIsPaymentSuccessful={setIsPaymentSuccessful}
    />
  );

  const Hero = (
    <HeroSection
      data={heroSectionData}
      scrollToForm={scrollToForm}
      scrollToHowItWorks={scrollToHowItWorks}
      h1Text={h1Text}
    />
  );

  const Testimonials = (
    <StyledTestimonials
      data={testimonialsData}
      isMobile={isMobile}
      removeFixBtn={testimonialsRef}
    />
  );

  const LeadNutritionistVideo = (
    <NutritionistVideo
      data={leadNutritionistData}
      scrollToForm={scrollToForm}
    />
  );

  const HowItWorks = (
    <HowItWorksSection
      data={howItWorksData}
      formRef={formRef}
      howItWorksRef={howItWorksRef}
    >
      {Form}
    </HowItWorksSection>
  );

  // const Help = <HelpSection data={helpSectionData} />;

  const Features = <FeaturesSection data={featuresSectionData} />;

  return (
    <MainTemplate
      darkHeader={headerValue.dark}
      headerBackgroundColor={headerValue.color}
      isStickyHeader={headerValue.isSticky}
      // isLoading={isLoading}
      error={error}
    >
      {isPaymentSuccessful ? (
        <PaymentSuccessSection
          data={{ ...formData?.success, mobile: userMobileNumber }}
        />
      ) : (
        <>
          {Hero}
          {isMobile && Testimonials}
          {isMobile && LeadNutritionistVideo}
          {HowItWorks}
          {!isMobile && LeadNutritionistVideo}
          {/* {Help} */}
          {Features}
          {!isMobile && Testimonials}
        </>
      )}
    </MainTemplate>
  );
}

export default NutritionPackagesPage;
